module.exports = __webpack_public_path__ + "img/8.244331c2.png";